import { render, staticRenderFns } from "./codeItem.vue?vue&type=template&id=3fcc46f5&scoped=true"
import script from "./codeItem.vue?vue&type=script&lang=js"
export * from "./codeItem.vue?vue&type=script&lang=js"
import style0 from "./codeItem.vue?vue&type=style&index=0&id=3fcc46f5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc46f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fcc46f5')) {
      api.createRecord('3fcc46f5', component.options)
    } else {
      api.reload('3fcc46f5', component.options)
    }
    module.hot.accept("./codeItem.vue?vue&type=template&id=3fcc46f5&scoped=true", function () {
      api.rerender('3fcc46f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/codeItem.vue"
export default component.exports